export default __webpack_public_path__ + "static/media/nest.fea48fb1.svg";